import { isPromise } from '@ff-os/shared-utils/isPromise';
import { IDT } from './IDT';

let bindings = {
    refreshAuthorization: null as IDT.RefreshAuthorization | null
};

export const bindRefreshAuthorization = (refresh: IDT.RefreshAuthorization) => {
    bindings.refreshAuthorization = refresh;
};

export const refreshAuthorization = async (projectId: string) => {

    if (!bindings.refreshAuthorization) {
        throw new Error('Refresh callback was not implemented.');
    }

    const promise = bindings.refreshAuthorization(projectId);

    if (!isPromise(promise)) {
        throw new Error('Refresh callback did not return a promise.');
    }

    const jwt = await promise;

    // noinspection SuspiciousTypeOfGuard
    if (typeof jwt !== 'string') {
        throw new Error(`Refresh callback did not return a string, but ${typeof jwt}.`);
    }

    return jwt;
};